document.addEventListener("DOMContentLoaded", function () {
  const thumbsSwiper = new Swiper(".product-thumbs-swiper", {
    direction: "vertical",
    spaceBetween: 20,
    slidesPerView: "auto",
    speed: 600,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    breakpoints: {
      0: {
        direction: "vertical",
        slidesPerView: 4.5,
        spaceBetween: 5,
      },
      992: {
        direction: "horizontal",
        slidesPerView: 5,
        spaceBetween: 8,
      },
      1401: {
        direction: "vertical",
        slidesPerView: 5,
        spaceBetween: 8,
      },
    },
  });

  // Main product media swiper
  const mainSwiper = new Swiper(".product-media-swiper", {
    spaceBetween: 10,
    loop: true,
    speed: 600,
    navigation: {
      nextEl: ".product_main_next",
      prevEl: ".product_main_prev",
    },
    thumbs: {
      swiper: thumbsSwiper,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 25,
      },
      769: {
        slidesPerView: 1,
        spaceBetween: 25,
      },
    },
  });
});
